document.addEventListener("DOMContentLoaded", function () {

  // Initialize every Featured Tabs Products section
  document.querySelectorAll(".tabs-products").forEach(function (section) {

    const buttons = section.querySelectorAll(".tab-btn");
    const tabs = section.querySelectorAll(".tab-content");

    // Skip if section has no tabs
    if (!buttons.length || !tabs.length) return;

    buttons.forEach(function (button) {

      button.addEventListener("click", function () {

        // Remove active class from all buttons
        buttons.forEach(function (btn) {
          btn.classList.remove("active");
        });

        // Hide all tab contents
   tabs.forEach(function (tab) {

    tab.classList.remove("active");

    tab.style.animation = "none";

});

        // Activate clicked button
        button.classList.add("active");

        // Show selected tab
        const target = section.querySelector("#" + button.dataset.tab);

       if (target) {

    target.offsetHeight;

    target.style.animation = "";

    target.classList.add("active");




          // Reset product scroll position to the beginning
          const scroller = target.querySelector(".productsScroller");

          if (scroller) {
            scroller.scrollTo({
              left: 0,
              behavior: "smooth"
            });
          }
        }

      });

    });

  });

});